import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
//import { VersionSociedad } from '../interfaces/beans.interface';

/////////CLASE PARA GENERAR ARCHIVOS DESPUES DEL AUMENTO DE CAPITAL
class Aumento {
  rfc: string;
  asiento: number;
  sociedad: string;
  fecha: Date;
  capitalAumento: number;
  totalCapital: number;
  capitalFijo: number;
  capitalVariable: number;
  capitalFijoTotal: number;
  capitalVariableTotal: number;
  accionesFijoTotal: number;
  accionesVariableTotal: number;
  accionesTotal: number;
  accionesFijasAnterioresTotales: number;
  accionesVariablesAnterioresTotales: number;
  capitalFijasAnterioresTotales: number;
  capitalVariableAnterioresTotales: number;
  capitalAnterioresTotales: number;
  delegado1: string;
  delegado2: string;
  delegado3: string;
  leyendaDisminucionCapital: string;
  accionista: AccionistaAumento [];
}

class AccionistaAumento {
  nombre: string;
  rfc: string;
  domicilio: string;
  numeroAcciones: number;
  capitalFijo: number;
  accionesFijo: number;
  capitalVariable: number;
  accionesVariable: number;
  totalCapital: number;
  capitalFijoTotal: number;
  accionesFijoTotal: number;
  capitalVariableTotal: number;
  accionesVariableTotal: number;
  porcentajeConsolidado: number;
  accionesFijasAnterioresTotales: number;
  accionesVariablesAnterioresTotales: number;
  capitalFijasAnterioresTotales: number;
  capitalVariableAnterioresTotales: number;
  capitalAnterioresTotales: number;
  porcentajeAnteriorConsolidado: number;
}
/////////////////////////////////////

//Clase necesaria para añadir una nueva version a la sociedad
class VersionSociedad {
  fecha: Date;
  version: number;
  valorNominal: number;
  numeroAcciones: number;
  capitalSocial: number;
  capSocPfija: number;
  capSocPvariable: number;
  rfcSociedad: RfcSociedad;
  delegado1: string;
  delegado2: string;
  delegado3: string;
  concepto: string;
}

class VersionSociedadUpdate {
  id: number;
  fecha: Date;
  version: number;
  valorNominal: number;
  numeroAcciones: number;
  capitalSocial: number;
  capSocPfija: number;
  capSocPvariable: number;
  rfcSociedad: RfcSociedad;
  delegado1: string;
  delegado2: string;
  delegado3: string;
  concepto: string;
}

class RfcSociedad {
  rfc: string;
}
///////////////////////////////////

//Clase necesaria para añadir la nueva version de los accionistas
class AccionistasNuevaVersion {
  porcCapFijo: number;
  porcCapVar: number;
  totalAcciAcci: number;
  totalCap: number;
  capitalFijo: number;
  capitalVariable: number;
  rfcAccionista: RfcAccionista;
  idVersion: IdVersionSociedad;
  descripcion: string;
}

class RfcAccionista {
  rfc: string;
}

class IdVersionSociedad {
  id: number;
}
///////////////////////////////////

@Injectable({
  providedIn: 'root'
})

export class VersionService {
  url = environment.url3 + '/version';
  url2 = environment.url2 + '/datosAccionistas';
  url3 = environment.url3 + '/generarPdf';

  constructor(private http: HttpClient) {}


  //Documentos de aumento definitivo 
  generarLibroVariacionesCapital(idVersion: number, rfcSociedad: string) {
    // let headers = new HttpHeaders()
    // .append('Content-Type', 'application/json')
    // .append('Autorizzazione', localStorage.getItem('token'));
    // return this.http.post(`${ this.url3 }/createLibroDeVariacionesDeCapitalAumento?idVersion=${ idVersion }&rfcSociedad=${ rfcSociedad }`, { headers }).pipe( map( data => data));
    const headers = new HttpHeaders()
    .append('Autorizzazione', localStorage.getItem('token'));

    const formData: FormData = new FormData();

    formData.append('rfcSociedad', rfcSociedad);
    formData.append('idVersion', idVersion.toString());

    console.log("INSIDE: -> generarLibroRegistroDeAcciones => ");
    console.trace();
    return this.http.post(`${ this.url3 }/createLibroDeVariacionesDeCapitalAumento`,formData, { headers }).pipe( map( data => data));
  }

  generarLibroDeRegistroDeAccionesActaManual(idVersion: number, rfcSociedad: string,) {
    // let headers = new HttpHeaders()
    // .append('Content-Type', 'application/json')
    // .append('Autorizzazione', localStorage.getItem('token'));
    // return this.http.post(`${ this.url3 }/createLibroRegistroDeAccionesActaManual?idVersion=${ idVersion }&rfcSociedad=${ rfcSociedad }`, { headers }).pipe( map( data => data));
    const headers = new HttpHeaders()
    .append('Autorizzazione', localStorage.getItem('token'));

    const formData: FormData = new FormData();

    formData.append('rfcSociedad', rfcSociedad);
    formData.append('idVersion', idVersion.toString());

    console.log("INSIDE: -> generarLibroRegistroDeAcciones => ");
    console.trace();
    return this.http.post(`${ this.url3 }/createLibroRegistroDeAccionesActaManual`,formData, { headers }).pipe( map( data => data));
  }

  generarLibroVariacionesCapitalActaManual(idVersion: number, rfcSociedad: string) {
    console.log('ENTRO A LA ACTA MANUAL NUEVA');
    // let headers = new HttpHeaders()
    // .append('Content-Type', 'application/json')
    // .append('Autorizzazione', localStorage.getItem('token'));
    // return this.http.post(`${ this.url3 }/createLibroDeVariacionesActaManual?idVersion=${ idVersion }&rfcSociedad=${ rfcSociedad }`, { headers }).pipe( map( data => data));
    const headers = new HttpHeaders()
    .append('Autorizzazione', localStorage.getItem('token'));

    const formData: FormData = new FormData();

    formData.append('rfcSociedad', rfcSociedad);
    formData.append('idVersion', idVersion.toString());

    console.log("INSIDE: -> generarLibroRegistroDeAcciones => ");
    console.trace();
    //return this.http.post(`${ this.url3 }/createLibroRegistroDeAcciones/?rfcSociedad=${ rfcSociedad }&idVersion=${ idVersion }`,{ headers }).pipe( map( data => data));
    return this.http.post(`${ this.url3 }/createLibroDeVariacionesActaManual`, formData, { headers }).pipe( map( data => data));
    // return this.http.post(`${ this.url3 }/createLibroRegistroDeAcciones`,formData,{ headers }).pipe( map( data => data));
  }

  generarLibroDeRegistroDeAccionesAumento(idVersion: number, rfcSociedad: string,) {
    // let headers = new HttpHeaders()
    // .append('Content-Type', 'application/json')
    // .append('Autorizzazione', localStorage.getItem('token'));
    // return this.http.post(`${ this.url3 }/createLibroDeRegistroDeAccionesAumento?rfcSociedad=${ rfcSociedad }&idVersion=${ idVersion }`, { headers }).pipe( map( data => data));
    const headers = new HttpHeaders()
    .append('Autorizzazione', localStorage.getItem('token'));

    const formData: FormData = new FormData();

    formData.append('rfcSociedad', rfcSociedad);
    formData.append('idVersion', idVersion.toString());

    console.log("INSIDE: -> generarLibroRegistroDeAcciones => ");
    console.trace();
    return this.http.post(`${ this.url3 }/createLibroDeRegistroDeAccionesAumento`,formData, { headers }).pipe( map( data => data));    
  }

  generarCreateRUFASAumento(idVersion: number, rfcSociedad: string) {
    // let headers = new HttpHeaders()
    // .append('Content-Type', 'application/json')
    // .append('Autorizzazione', localStorage.getItem('token'));
    // return this.http.post(`${ this.url3 }/createRUFASAumento?rfcSociedad=${ rfcSociedad }&idVersion=${ idVersion }`, { headers }).pipe( map( data => data));
    const headers = new HttpHeaders()
    .append('Autorizzazione', localStorage.getItem('token'));

    const formData: FormData = new FormData();

    formData.append('rfcSociedad', rfcSociedad);
    formData.append('idVersion', idVersion.toString());

    console.log("INSIDE: -> generarLibroRegistroDeAcciones => ");
    console.trace();
    return this.http.post(`${ this.url3 }/createRUFASAumento`, formData, { headers }).pipe( map( data => data));
  }

  //CREACION DE LOS DOCUMENTOS DE APERTURA ok
  generarLibroRegistroDeAcciones(rfcSociedad: string, idVersion: number) {
    const headers = new HttpHeaders()
    .append('Autorizzazione', localStorage.getItem('token'));

    const formData: FormData = new FormData();

    formData.append('rfcSociedad', rfcSociedad);
    formData.append('idVersion', idVersion.toString());

    console.log("INSIDE: -> generarLibroRegistroDeAcciones => ");
    console.trace();
    //return this.http.post(`${ this.url3 }/createLibroRegistroDeAcciones/?rfcSociedad=${ rfcSociedad }&idVersion=${ idVersion }`,{ headers }).pipe( map( data => data));
    return this.http.post(`${ this.url3 }/createLibroRegistroDeAcciones`,formData,{ headers }).pipe( map( data => data));
  }

  
  generarLibroRegistroActasAsamblea(rfcSociedad: string, idVersion: number) {
    const headers = new HttpHeaders()
    .append('Autorizzazione', localStorage.getItem('token'));

    const formData: FormData = new FormData();

    formData.append('rfcSociedad', rfcSociedad);
    formData.append('idVersion', idVersion.toString());

    console.log("INSIDE: -> generarLibroRegistroActasAsamblea => ");
    console.trace();
    // return this.http.post(`${ this.url3 }/createLibroRegistroDeActasDeAsamblea?rfcSociedad=${ rfcSociedad }&idVersion=${ idVersion }`, { headers }).pipe( map( data => data));
    return this.http.post(`${ this.url3 }/createLibroRegistroDeActasDeAsamblea`,formData, { headers }).pipe( map( data => data));
  }

  generarLibroRegistroSesionConsejoDelOrganoDeAdministracion(rfcSociedad: string, idVersion: number) {
    const headers = new HttpHeaders()
    .append('Autorizzazione', localStorage.getItem('token'));

    const formData: FormData = new FormData();

    formData.append('rfcSociedad', rfcSociedad);
    formData.append('idVersion', idVersion.toString());

    console.log("INSIDE: -> generarLibroRegistroSesionConsejoDelOrganoDeAdministracion => ");
    console.trace();
    // return this.http.post(`${ this.url3 }/createLibroRegistroDeSesionDelOrganoDeAdministracion?rfcSociedad=${ rfcSociedad }&idVersion=${ idVersion }`, { headers }).pipe( map( data => data));
    return this.http.post(`${ this.url3 }/createLibroRegistroDeSesionDelOrganoDeAdministracion`,formData, { headers }).pipe( map( data => data));
  }

  generarLibroVariacionesDeCapital(rfcSociedad: string, idVersion: number) {
    const headers = new HttpHeaders()
    .append('Autorizzazione', localStorage.getItem('token'));

    const formData: FormData = new FormData();

    formData.append('rfcSociedad', rfcSociedad);
    formData.append('idVersion', idVersion.toString());

    console.log("INSIDE: -> generarLibroRegistroSesionConsejoDelOrganoDeAdministracion => ");
    console.trace();
    // .append('Content-Type', 'application/json')
    // .append('Access-Control-Allow-Origin', environment.urlLocal);
    // return this.http.post(`${ this.url3 }/createLibroDeVariacionesDeCapital?rfcSociedad=${ rfcSociedad }&idVersion=${ idVersion }`,{ headers }).pipe( map( data => data));
    return this.http.post(`${ this.url3 }/createLibroDeVariacionesDeCapital`,formData,{ headers }).pipe( map( data => data));
  }

  //////////////////////////////////////////////

  findVersionSociedad( rfcSociedad: string) {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));
    return this.http.post(`${ this.url }/id`, rfcSociedad, { headers }).pipe( map( data => data));
  }

  addVersionSociedad(versionS: VersionSociedad) {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));
    return this.http.post(`${ this.url }/add`, versionS, { headers }).pipe( map( data => data));
  }

  updateAsamblea(versionS: VersionSociedadUpdate) {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));
    return this.http.post(`${ this.url }/update/Asamblea`, versionS, { headers }).pipe( map( data => data));
  }

  deleteVersion(idVersion: number) {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));
    return this.http.delete(`${ this.url }/delete/${ idVersion }`, { headers }).pipe( map( data => data));
  }
  //////////////////////////////////////////////

  addVersionAccionista(versionA: string) {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));
    return this.http.post(`${ this.url2 }/add`, versionA, { headers }).pipe( map( data => data));
  }

  addAccionistaVersion(versionA: AccionistasNuevaVersion) {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));
    return this.http.post(`${ this.url2 }/add`, versionA, { headers }).pipe( map( data => data));
  }

  countAccionistasVersiones() {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));
    return this.http.get(`${ this.url2 }/count`, { headers }).pipe( map( data => data));
  }

  countSociedadVersiones(rfcSociedad: string) {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));
    return this.http.get(`${ this.url }/count/${ rfcSociedad }`, { headers }).pipe( map( data => data));
  }

  getAll(paginaActual: number, registrosPorPagina: number, version: number) {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));
    console.log(this.url2, '/version?pagina=',  paginaActual, '&registros=', registrosPorPagina , '&version=' , version );
    return this.http.get(`${ this.url2 }/version?pagina=${ paginaActual }&registros=${ registrosPorPagina }&version=${ version }`, { headers }).pipe( map( data => data));
  }

  getAccionistasVersion(paginaActual: number, registrosPorPagina: number, idversion: number) {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));
    //console.log(this.url2, '/version?pagina=',  paginaActual, '&registros=', registrosPorPagina , '&version=' , idversion );
    return this.http.get(`${ this.url2 }/version?pagina=${ paginaActual }&registros=${ registrosPorPagina }&version=${ idversion }`, { headers }).pipe( map( data => data));
  }

  delete(idUsr: String) {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));
    return this.http.delete(`${ this.url }/delete/${ idUsr }`,  { headers }).pipe( map( data => data));
  }

  getListVersionSociedad(rfcSociedad: string) {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));
    return this.http.get(`${ this.url }/listaVersion/${ rfcSociedad }`,  { headers }).pipe( map( data => data));
  }
}
